const storeSuffix = 'AppOptions';

import Vue from 'vue';

// Mutations
export const SET_SHOW_COMPANY_HEADER = `setShowCompanyHeaderMutation${storeSuffix}`;
export const SET_SHOW_MOBILE_MENU = `setShowMobileMenuMutation${storeSuffix}`;

// Getters
export const GET_SHOW_COMPANY_HEADER = `getShowCompanyHeaderGetter${storeSuffix}`;
export const GET_SHOW_MOBILE_MENU = `getShowMobileMenuGetter${storeSuffix}`;

export const modelState = () => ({
    appOptions: {
        showCompanyHeader: false,
        showMobileMenu: false
    },
});

export const mutations = {
    [SET_SHOW_COMPANY_HEADER]: (state, boolean) => {
        state.appOptions.showCompanyHeader = boolean;
    },
    [SET_SHOW_MOBILE_MENU]: (state, boolean) => {
        state.appOptions.showMobileMenu = boolean;
    }
};

export const getters = {
    [GET_SHOW_COMPANY_HEADER]: state => {
        return state.appOptions.showCompanyHeader;
    },
    [GET_SHOW_MOBILE_MENU]: state => {
        return state.appOptions.showMobileMenu;
    }
};



// WEBPACK FOOTER //
// ./src/store/store-models/app-model.js